import React from 'react';
import { SpinnerReact } from 'common/components/spinner';
import { SpinnerSize } from 'common/components/spinner/types';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { ExperimentPageProvider } from '../context';
import { ListPageTrackingEvent, trackExperimentListPageAction } from '../tracking';
import { useQueryExperimentList } from '../hooks/query-experiment-list';
import styles from './index.module.styl';
import { ExperimentListPageHeader } from './header';
import { ExperimentListPageMain } from './main';
type ExperimentListPageProps = {
  projectId: number;
  workspaceId: number;
  userId: number;
};
export function ExperimentListPage(_ref: ExperimentListPageProps) {
  let {
    projectId,
    workspaceId,
    userId
  }: ExperimentListPageProps = _ref;
  const experiments = useExperimentsStore(state => state.experiments);
  useQueryExperimentList({
    projectId,
    workspaceId
  });
  React.useEffect(() => {
    trackExperimentListPageAction({
      event: ListPageTrackingEvent.PageLoaded
    });
  }, []);
  if (experiments === undefined) {
    return <SpinnerReact size={SpinnerSize.Large} />;
  }
  return <ExperimentPageProvider projectId={projectId} workspaceId={workspaceId} userId={userId} data-sentry-element="ExperimentPageProvider" data-sentry-component="ExperimentListPage" data-sentry-source-file="index.tsx">
      <div className={styles.wrapper}>
        <ExperimentListPageHeader data-sentry-element="ExperimentListPageHeader" data-sentry-source-file="index.tsx" />
        <ExperimentListPageMain data-sentry-element="ExperimentListPageMain" data-sentry-source-file="index.tsx" />
      </div>
    </ExperimentPageProvider>;
}